module.exports = __webpack_public_path__ + "public/img/pad.daf48dca.png";